<template>
  <span class="base-mit-chart-pie">
      <canvas id="mitChartPieId"></canvas>
  </span>
</template>

<script>
  import Chart from 'chart.js/auto';

export default {
  name: 'BaseMitChartPie',
  components: {
  },
  props: {
    pieData:{
        default() {
            return {
                labels:[],
                values:[]
            }
        },
        type: Object
    },
    title: {
        default: 'Default Title',
        type: String
    },
    label:{
        default: 'Default X Label',
        type: String
    },
    legendPosition:{
        default: 'bottom',
        type: String
    },
    backgroundColor: {
        default() {
            return [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)'
            ]
        },
        type: Array
    },
    borderColor: {
        default() {
            return [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)'
            ]
        },
        type: Array
    }
  },
  data: function() {
    return {
    }
  },
  created() {
  },
  mounted() {
      const ctxPie = document.getElementById('mitChartPieId');
      const pie = new Chart(ctxPie, {
            type: 'pie',
            data:{
              labels: this.pieData.labels,
              datasets: [{
                label: this.label,
                data: this.pieData.values,
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                hoverOffset: 4,
                borderWidth: 1,
              }]
            },
            options: {
                responsive: true,
                plugins: {
                  legend: {
                    position: this.legendPosition,
                  },
                  title: {
                    display: true,
                    text: this.title
                  }
                }
            }
        });
  },
  methods : {

  }
}
</script>

<style lang="scss" scoped>

</style>
